import React from "react";
import { Play, Apple } from "lucide-react";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=ai.namable.app";

export function StoreBadges({ className = "" }) {
  return (
    <div className={`flex flex-wrap gap-2.5 ${className}`}>
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="play-store-link"
        className="inline-flex items-center gap-2.5 rounded-lg px-3.5 py-2 text-white transition-transform duration-200 hover:scale-[1.03]"
        style={{ background: "linear-gradient(160deg,#141a2e,#0d1120)" }}
      >
        <Play size={20} className="fill-white" />
        <span className="flex flex-col leading-none text-left">
          <span className="text-[9px] uppercase tracking-wide text-white/70">Get it on</span>
          <span className="text-[14px] font-bold">Google Play</span>
        </span>
      </a>

      <div
        data-testid="app-store-badge"
        aria-disabled="true"
        title="Coming soon to the App Store"
        className="inline-flex items-center gap-2.5 rounded-lg px-3.5 py-2 text-white opacity-60 cursor-default"
        style={{ background: "linear-gradient(160deg,#141a2e,#0d1120)" }}
      >
        <Apple size={20} className="fill-white" />
        <span className="flex flex-col leading-none text-left">
          <span className="text-[9px] uppercase tracking-wide text-white/70">Coming soon</span>
          <span className="text-[14px] font-bold">App Store</span>
        </span>
      </div>
    </div>
  );
}
